import React from 'react'
import { DotProps, CarouselProps as BaseCarouselProps } from 'react-multi-carousel/lib/types'
import MultiCarousel from 'react-multi-carousel'
import { classNames } from 'services/string'
import 'react-multi-carousel/lib/styles.css'

/** Constante que representa a largura máxima de tamanho da tela para breakpoints cuja largura máxima não esteja claramente definida. */
export const BREAKPOINT_MAX_WIDTH = 1_000_000

interface CustomDotsProps extends DotProps {
  labelled?: boolean
  contrast?: boolean
}

const CustomDots = ({ active, onClick, index, labelled, contrast }: CustomDotsProps) => {
  const dotClasses = labelled ? 'text-xs font-medium flex justify-center items-center h-8 w-8 text-white' : 'w-3 h-3'
  const dotColors = {
    base: contrast ? 'bg-white' : 'bg-primary-800',
    active: contrast ? 'ring-2 ring-white' : 'ring-2 ring-primary-800',
  }

  return (
    <li
      className={classNames(dotClasses, dotColors.base, 'mx-2 rounded-full shadow-lg cursor-pointer', active && dotColors.active)}
      onClick={() => onClick?.()}
    >
      {labelled && typeof index === 'number' ? index + 1 : ''}
    </li>
  )
}

interface CarouselProps extends BaseCarouselProps {
  labelledDots?: boolean
  contrastDots?: boolean
}

const Carousel = ({ children, labelledDots = false, contrastDots = false, ...rest }: CarouselProps) => {
  return (
    <MultiCarousel {...rest} customDot={<CustomDots labelled={labelledDots} contrast={contrastDots} />}>
      {children}
    </MultiCarousel>
  )
}

export default Carousel
